module.exports = __webpack_public_path__ + "media/images/corporate-logos/logo-indians-d2914469dd8ec2dfe5d136a2d6018c36.svg";